// extracted by mini-css-extract-plugin
export default {"state":"OrderInWay_state__Q4a+d","state_btn":"OrderInWay_state_btn__Ooh+h"};